
export default {
  props: {
    label: String,
    content: Boolean
  },

  computed: {
    _content: {
      set (value) {
        this.$emit('update:content', value)
      },

      get () {
        return this.content
      }
    }
  },

  mounted () {
    if (this.content === undefined) this._content = false
  }
}
